import React, { Component } from 'react'
import './App.css'

let Footer = () =>

	<section className="content content--related">
      <ul id="crew">
		<li id="journalist">
			<span className="items">採寫: </span>
			<span className="names">江雁南、何欣潔</span>
		</li>
		<li id="editors">
			<span className="items">編輯: </span>
			<span className="names">陳筑君、曾柏文、李志德</span>
		</li>
		<li id="photographers">
			<span className="items">攝影: </span>
			<span className="names">Billy H.C. Kwok、徐翌全、張國耀</span>
		</li>
		<li id="photoeditor">
			<span className="items">圖片編輯: </span>
			<span className="names">Anthony Kwan、羅國輝</span>
		</li>
		<li id="researchers">
			<span className="items">數據分析: </span>
			<span className="names">徐小童、程一祥、沈書緣</span>
		</li>
		<li id="designers">
			<span className="items">設計: </span>
			<span className="names">曾立宇</span>
		</li>
		<li id="frontend">
			<span className="items">製作: </span>
			<span className="names">金秋楓</span>
		</li>
		<li id="advisor">
			<span className="items">監製: </span>
			<span className="names">張潔平</span>
		</li>
	</ul>
    </section>

export default Footer


/** WEBPACK FOOTER **
 ** ./src/Footer.js
 **/